import React from "react";
import TemperatureBar from "./TemperatureBar";

const ComparisonSection = ({
  today = { min: 0, max: 0 },
  yesterday = { min: 0, max: 0 },
  tomorrow = { min: 0, max: 0 },
}) => {
  // Ensure we have valid numbers for calculations
  const safeTemp = (temp) => {
    const num = Number(temp);
    return isNaN(num) ? 0 : num;
  };

  const todayMin = safeTemp(today.min);
  const todayMax = safeTemp(today.max);
  const yesterdayMin = safeTemp(yesterday.min);
  const yesterdayMax = safeTemp(yesterday.max);
  const tomorrowMin = safeTemp(tomorrow.min);
  const tomorrowMax = safeTemp(tomorrow.max);

  // Calculate the range for the temperature bars
  const allTemps = [
    todayMin,
    todayMax,
    yesterdayMin,
    yesterdayMax,
    tomorrowMin,
    tomorrowMax,
  ];
  const minTemp = Math.min(...allTemps);
  const maxTemp = Math.max(...allTemps);

  return (
    <div className="bg-white rounded-lg p-4">
      <div className="divide-y divide-gray-200">
        <div className="flex items-center justify-between py-4 first:pt-0">
          <span className="w-24">Today</span>
          <div className="flex-1">
            <TemperatureBar
              minTemp={todayMin}
              maxTemp={todayMax}
              globalMinTemp={minTemp}
              globalMaxTemp={maxTemp}
            />
          </div>
        </div>

        <div className="flex items-center justify-between py-4">
          <span className="w-24">Yesterday</span>
          <div className="flex-1">
            <TemperatureBar
              minTemp={yesterdayMin}
              maxTemp={yesterdayMax}
              globalMinTemp={minTemp}
              globalMaxTemp={maxTemp}
            />
          </div>
        </div>

        <div className="flex items-center justify-between py-4">
          <span className="w-24">Tomorrow</span>
          <div className="flex-1">
            <TemperatureBar
              minTemp={tomorrowMin}
              maxTemp={tomorrowMax}
              globalMinTemp={minTemp}
              globalMaxTemp={maxTemp}
            />
          </div>
        </div>
      </div>

      {todayMax < yesterdayMax && (
        <p className="text-sm text-gray-400 mt-6">
          The maximum temperature is lower today than yesterday.
        </p>
      )}
    </div>
  );
};

export default ComparisonSection;
